// import PropTypes from 'prop-types';

import { Outlet } from 'react-router-dom';
import BrandBand from '@salesforce/design-system-react/components/brand-band';
import GenericToast from './GenericToast';
import ErrorModal from './ErrorModal';

const Layout = () => {
  return (
    <>
      <BrandBand
        id="brand-band-lightning-blue"
        className="slds-brand-band slds-brand-band_cover slds-brand-band_medium  brand-band_magnetic forceBrandBand"
        style={{
          minHeight: '100vh'
        }}
        size="medium"
      >
        <Outlet />
      </BrandBand>
      <GenericToast />
      <ErrorModal />
    </>
  );
};

export default Layout;
